import ClientEpics from './client'
import DataLayerEpics from './dataLayer'

export default [...ClientEpics, ...DataLayerEpics]
